import { useQuery } from '@tanstack/react-query';
import { FEATURES } from 'constants/features';
import { featureFlags } from 'services/featureFlags/featureFlags';
import { isTestEnvironment } from 'utils/environment/environment';
import { queryKeys } from '../queryKeys';

export const useDefaultFlags = () => {
  return useQuery({
    queryKey: queryKeys.flags.by(...FEATURES),
    queryFn: () => featureFlags.fetch(FEATURES),
    staleTime: isTestEnvironment() ? 0 : Infinity,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    refetchInterval: false,
  });
};
